import Vue from "vue";
import axios from 'axios';
import router from '@/router'

// 记录用户原来的页面
let lastPage = window.location.href;

// 创建 axios 实例
const instance = axios.create({
	baseURL: process.env.VUE_APP_API_URL + '/api/',
	timeout: 60000,
	headers: {
		'Content-Type': 'application/json'
	},
});

// 请求拦截器
instance.interceptors.request.use(
	(config) => {

		if (config.showLoading) {
			Vue.prototype.$loading.show();
		}

		// 添加认证 token
		const token = localStorage.getItem('token');
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}

		return config;
	},
	(error) => {

		console.log('请求错误:', error);
		return Promise.reject(error);
	}
);

// 响应拦截器
instance.interceptors.response.use(
	(response) => {
		if (response.config.showLoading) {
			Vue.prototype.$loading.hide();
		}

		return response.data;
	},
	(error) => {
		console.log(error)
		if (error.config && error.config.showLoading) {
			Vue.prototype.$loading.hide();
		}

		if (error.code === 'ECONNABORTED') {
			console.log('请求超时:', error.message);
			Vue.prototype.$loading.hide();
		} else if (error.response) {
			if (error.response.status == 401) {
				Vue.prototype.$messageBox({
					title: '友情提示',
					message: '登录信息已失效，请重新登录',
					confirmText: '去登录',
					showCancel: false,
					maskEvent: false,
					onConfirm: () => {
						localStorage.removeItem('token');
						router.replace('/')
					}
				})
			}
			console.log(`响应错误: 状态码 ${error.response.status}`, error.response.data);
			Vue.prototype.$loading.hide();
		}
		else if (error.code === "ERR_NETWORK") {
			if (process.env.NODE_ENV === 'development') {
				console.log('开发环境网络错误，不跳转维护页');
				return;
			}
			sessionStorage.setItem("lastPage", lastPage);
			return;
		}

		else {
			console.log('请求失败:', error.message);
			Vue.prototype.$loading.hide();
		}

		return Promise.reject(error);
	}
);

const request = {
	async get(url, showLoading = true, params = {}, config = {}) {
		try {
			const response = await instance.get(url, {
				params,
				showLoading,
				...config
			});
			return response;
		} catch (error) {
			return null;
		}
	},

	async post(url, data = {}, showLoading = true, config = {}) {
		try {
			const response = await instance.post(url, data, {
				showLoading,
				...config
			});
			return response;
		} catch (error) {
			return null;
		}
	},

	async put(url, data = {}, showLoading = true, config = {}) {
		try {
			const response = await instance.put(url, data, {
				showLoading,
				...config
			});
			return response;
		} catch (error) {
			return null;
		}
	},

	async delete(url, params = {}, showLoading = true, config = {}) {
		try {
			const response = await instance.delete(url, {
				params,
				showLoading,
				...config
			});
			return response;
		} catch (error) {
			return null;
		}
	}
};

export default request;